
  export default {
    name: 'ThemeStoresMobileAndroidComments',
    computed: {
      pwa() {
        return this.$store.state['banner-pwa'].pwa
      },
      comments() {
        return [
          {
            id: 1,
            name: this.tl('firstCommentUser'),
            averageRating: 5,
            date: this.tl('firstCommentDate'),
            textContent: this.tl('firstCommentContent')
          },
          {
            id: 2,
            name: this.tl('secondCommentUser'),
            averageRating:
              ~~this.pwa?.pwa_app_settings?.overall_ratings === 5
                ? 5
                : ~~this.pwa?.pwa_app_settings?.overall_ratings,
            date: this.tl('secondCommentDate'),
            textContent: this.tl('secondCommentContent')
          }
        ]
      }
    },
    methods: {
      getPartialFillWidth() {
        const decimalPart = this.averageRating % 1
        return decimalPart ? decimalPart * 100 : 0
      }
    }
  }
